import * as React from 'react'
import { SVGProps } from 'react'
const SvgReplay = (props: SVGProps<SVGSVGElement>) => (
  <svg height={510} viewBox="0 0 510 510" width={510} {...props}>
    <path d="M255 102V0L127.5 127.5 255 255V153c84.15 0 153 68.85 153 153s-68.85 153-153 153-153-68.85-153-153H51c0 112.2 91.8 204 204 204s204-91.8 204-204-91.8-204-204-204z" />
  </svg>
)
export default SvgReplay
